import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-hr-cta',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './hr-cta.html',
  styleUrls: ['./hr-cta.css'],
})
export class HrCtaComponent {}
